import styled from "styled-components";
import {
    LeftSection,
    SectionHeader,
    SectionTitle,
    ToggleContainer,
    ToggleLabel,
    Card,
    InputRow,
    InputLabel,
    Input,
    InputWrapper,
    ResetAllButton,
    DisabledOverlay,
} from "../shared/styled";

// ─── Layout ──────────────────────────────────────────────

export const Container = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 30px;
    padding: 20px;
    height: 100%;

    @media (max-width: 1200px) {
        gap: 20px;
        padding: 15px;
    }

    @media (max-width: 992px) {
        grid-template-columns: 1fr;
        gap: 20px;
        padding: 15px;
    }

    @media (max-width: 576px) {
        padding: 10px;
        gap: 15px;
    }
`;

export const Toggle = styled.button.attrs<{
    isActive: boolean;
    mainColor: string;
}>(({ isActive }) => ({
    type: "button",
    role: "switch",
    "aria-checked": isActive,
}))<{ isActive: boolean; mainColor: string }>`
    width: 50px;
    height: 26px;
    border-radius: 13px;
    border: none;
    background-color: ${({ isActive, mainColor }) =>
        isActive ? mainColor : "#ccc"};
    position: relative;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &::after {
        content: "";
        position: absolute;
        top: 3px;
        left: ${({ isActive }) => (isActive ? "27px" : "3px")};
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: white;
        transition: left 0.2s ease;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    }
`;

export const SmallToggle = styled.button.attrs<{
    isActive: boolean;
    mainColor: string;
}>(({ isActive }) => ({
    type: "button",
    role: "switch",
    "aria-checked": isActive,
}))<{ isActive: boolean; mainColor: string }>`
    width: 40px;
    height: 22px;
    border-radius: 11px;
    border: none;
    background-color: ${({ isActive, mainColor }) =>
        isActive ? mainColor : "#ccc"};
    position: relative;
    cursor: pointer;
    transition: background-color 0.2s ease;
    flex-shrink: 0;

    &::after {
        content: "";
        position: absolute;
        top: 2px;
        left: ${({ isActive }) => (isActive ? "20px" : "2px")};
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background-color: white;
        transition: left 0.2s ease;
    }
`;

export const LanguageTabs = styled.div`
    display: flex;
    gap: 5px;
    margin-bottom: 15px;
    flex-wrap: wrap;

    @media (max-width: 576px) {
        gap: 8px;
        justify-content: center;
    }
`;

export const LanguageTab = styled.button<{
    isActive: boolean;
    mainColor: string;
}>`
    padding: 6px 16px;
    border: 1px solid
        ${({ isActive, mainColor }) => (isActive ? mainColor : "#e0e0e0")};
    border-radius: 20px;
    background-color: ${({ isActive, mainColor }) =>
        isActive ? mainColor : "#fff"};
    color: ${({ isActive }) => (isActive ? "#fff" : "#333")};
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        border-color: ${({ mainColor }) => mainColor};
    }
`;

export const VisibilityButton = styled.button<{ isVisible: boolean }>`
    background: none;
    border: none;
    cursor: pointer;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ isVisible }) => (isVisible ? "#666" : "#ccc")};
    transition: all 0.2s ease;
    flex-shrink: 0;

    &:hover {
        color: #333;
    }

    svg {
        width: 18px;
        height: 18px;
    }
`;

export const ResetButton = styled.button<{ mainColor: string }>`
    background: none;
    border: none;
    cursor: pointer;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ mainColor }) => mainColor};
    transition: background-color 0.2s ease;
    border-radius: 4px;
    flex-shrink: 0;

    &:hover {
        background-color: ${({ mainColor }) => `${mainColor}20`};
    }

    svg {
        width: 18px;
        height: 18px;
    }
`;

export const MethodSection = styled.div`
    padding-top: 15px;
    margin-top: 15px;
    border-top: 2px solid #e0e0e0;

    &:first-of-type {
        margin-top: 5px;
        padding-top: 5px;
        border-top: none;
    }
`;

export const MethodSectionHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
`;

export const MethodIconCircle = styled.div<{ mainColor: string }>`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: ${({ mainColor }) => `${mainColor}15`};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    svg {
        width: 16px;
        height: 16px;
        fill: ${({ mainColor }) => mainColor};
    }
`;

export const MethodName = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: #333;
`;

// Shared layout primitives (see ../shared/styled).
export {
    LeftSection,
    SectionHeader,
    SectionTitle,
    ToggleContainer,
    ToggleLabel,
    Card,
    InputRow,
    InputLabel,
    Input,
    InputWrapper,
    ResetAllButton,
    DisabledOverlay,
};
